/**
 * L'Etape 26 – Core component
 */
/* jshint esversion: 6 */
var LEtape26 = (function () {
    'use strict';

    // ── Configurable delay before donut animation starts (ms) ──
    var DONUT_ANIMATION_DELAY = 250;

    function LEtape26() {
        // Constructor

        initDonutObserver();
        syncWarriorField();
        formSend();
        reelPlay();
        initStravaMaps();
        warriorsSlider();
    }

    function formSend() {
        const interval = setInterval(() => {
            const placeholder = document.querySelector('.form-done');
            const allDone = document.querySelector('.all-done');
            const confirmation = document.querySelector('.wpforms-confirmation-container-full');

            if (placeholder && allDone && confirmation) {
                // Make .all-done visible
                allDone.style.display = '';

                // Move .all-done inside confirmation container
                confirmation.appendChild(allDone);

                // Remove placeholder
                placeholder.remove();

                // Stop checking
                clearInterval(interval);
            }
        }, 100);
    }

    // ── Sync selected warrior into WPForms hidden field ──
    function syncWarriorField() {
        var $radios = jQuery('input[name="active-warrior[]"]');
        var $hidden = jQuery('input[name="wpforms[fields][18]"]');

        if (!$radios.length || !$hidden.length) {
            return;
        }

        // Set on page load from the checked radio
        $hidden.val($radios.filter(':checked').val() || '');

        // Update on change
        $radios.on('change', function () {
            $hidden.val(jQuery(this).val());
        });
    }

    // ── Viewport-triggered animations (donuts + week bars) ──
    var C        = 515.22;   // r=82, full circumference
    var ARC_HALF = 286.23;   // half-donut arc (200°)
    var animObserver = null;

    function animateDonut(el) {
        var $el    = jQuery(el);
        var pct    = parseInt($el.attr('data-value'), 10) || 0;
        var isFull = $el.hasClass('letape26-donut--full');
        var arc    = isFull ? C : ARC_HALF;
        var filled = arc * Math.min(pct, 100) / 100;
        var gap    = C - filled;
        var $value = $el.find('.letape26-donut__value');

        requestAnimationFrame(function () {
            $value.css('stroke-dasharray', filled + ' ' + gap);
        });
    }

    function animateBar(el) {
        var width = el.getAttribute('data-width') || '0';
        requestAnimationFrame(function () {
            el.style.width = width + '%';
        });
    }

    function initDonutObserver() {
        animObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                animObserver.unobserve(entry.target);
                setTimeout(function () {
                    if (entry.target.classList.contains('letape26-donut')) {
                        animateDonut(entry.target);
                    } else {
                        animateBar(entry.target);
                    }
                }, DONUT_ANIMATION_DELAY);
            });
        }, { threshold: 0.3 });

        observeAll();

        // Reset & re-animate on warrior switch
        jQuery('input[name="active-warrior[]"]').on('change', function () {
            resetAnimations();
        });

        // Re-animate bars when phase tab changes (bars live inside hidden panels)
        jQuery('input[type="radio"][name^="phase-"]').on('change', function () {
            jQuery('.letape26-weeks-overview__bar-fill').css('width', '0');
            setTimeout(function () {
                animateVisibleBars();
            }, 50);
        });

        // Initial animation for bars already visible on load
        setTimeout(function () {
            animateVisibleBars();
        }, DONUT_ANIMATION_DELAY);
    }

    function observeAll() {
        jQuery('.letape26-donut').each(function () {
            animObserver.observe(this);
        });
    }

    function animateVisibleBars() {
        jQuery('.letape26-weeks-overview__bar-fill:visible').each(function () {
            var el = this;
            setTimeout(function () {
                animateBar(el);
            }, DONUT_ANIMATION_DELAY);
        });
    }

    function resetAnimations() {
        // Reset donut strokes
        jQuery('.letape26-donut__value').css('stroke-dasharray', '0 ' + C);
        // Reset bar widths
        jQuery('.letape26-weeks-overview__bar-fill').css('width', '0');

        // Re-observe donuts + animate visible bars after CSS :has() toggle
        setTimeout(function () {
            jQuery('.letape26-donut').each(function () {
                animObserver.unobserve(this);
                animObserver.observe(this);
            });
            animateVisibleBars();
        }, 50);
    }

    // ── Click-to-play reel video ──────────────────────
    function reelPlay() {
        var $containers = jQuery('.reel-play[data-video-src]');

        $containers.each(function () {
            var $container = jQuery(this);
            var $button = $container.find('button');
            var videoSrc = $container.attr('data-video-src');
            var posterSrc = $container.attr('data-poster-src') || '';

            if (!videoSrc) {
                return;
            }

            $button.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Video already exists — resume playback
                var existingVideo = $container.find('video');
                if (existingVideo.length > 0) {
                    $button.hide();
                    existingVideo[0].play();
                    return;
                }

                // Create video element lazily
                var video = document.createElement('video');
                video.src = videoSrc;
                video.poster = posterSrc;
                video.autoplay = true;
                video.playsInline = true;
                video.preload = 'auto';
                video.style.cssText = 'width:100%;height:100%;object-fit:cover;position:absolute;top:0;left:0;cursor:pointer;';

                // Hide thumbnail and play button
                $container.find('> img').hide();
                $button.hide();

                $container.append(video);

                video.play().catch(function () {});

                // Click on video → pause
                video.addEventListener('click', function () {
                    video.pause();
                });

                // Show play button when paused or ended
                video.addEventListener('pause', function () {
                    $button.show();
                });

                video.addEventListener('ended', function () {
                    $button.show();
                });
            });
        });
    }

    // ── Strava activity map (Leaflet + encoded polyline) ──
    function decodePolyline(encoded) {
        var points = [];
        var index = 0, lat = 0, lng = 0;

        while (index < encoded.length) {
            var b, shift = 0, result = 0;
            do {
                b = encoded.charCodeAt(index++) - 63;
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);
            lat += ((result & 1) ? ~(result >> 1) : (result >> 1));

            shift = 0; result = 0;
            do {
                b = encoded.charCodeAt(index++) - 63;
                result |= (b & 0x1f) << shift;
                shift += 5;
            } while (b >= 0x20);
            lng += ((result & 1) ? ~(result >> 1) : (result >> 1));

            points.push([lat / 1e5, lng / 1e5]);
        }
        return points;
    }

    function initStravaMaps() {
        if (typeof L === 'undefined') {
            return;
        }

        jQuery('.strava-activity-map').each(function () {
            var el = this;
            var polyline = el.getAttribute('data-polyline');
            if (!polyline) {
                return;
            }

            var coords = decodePolyline(polyline);
            if (coords.length < 2) {
                return;
            }

            var map = L.map(el, {
                zoomControl: false,
                attributionControl: false,
                dragging: false,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                touchZoom: false,
                boxZoom: false,
                keyboard: false
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19
            }).addTo(map);

            // Orange track
            L.polyline(coords, {
                color: '#FC4C02',
                weight: 4,
                opacity: 0.9,
                lineJoin: 'round'
            }).addTo(map);

            // Blue start dot
            L.circleMarker(coords[0], {
                radius: 6,
                fillColor: '#2D71E6',
                fillOpacity: 1,
                color: '#fff',
                weight: 2
            }).addTo(map);

            // Fit map to show entire route with padding
            var bounds = L.latLngBounds(coords);
            map.fitBounds(bounds, { padding: [20, 20] });

            // Store reference for invalidateSize on warrior switch
            el._leafletMap = map;
            el._leafletBounds = bounds;
        });

        // When warrior radio changes, invalidate maps that become visible
        jQuery('input[name="active-warrior[]"]').on('change', function () {
            // Short delay to let CSS :has() toggle display
            setTimeout(function () {
                jQuery('.strava-activity-map').each(function () {
                    if (this._leafletMap && jQuery(this).is(':visible')) {
                        this._leafletMap.invalidateSize();
                        this._leafletMap.fitBounds(this._leafletBounds, { padding: [20, 20] });
                    }
                });
            }, 50);
        });
    }

    // ── Warriors slider (mobile only) ─────────────────
    function warriorsSlider() {
        if (window.innerWidth > 1023) {
            return;
        }

        var $list = jQuery('.letape26-warriors-list ul');
        if (!$list.length) {
            return;
        }

        // Wait for Owl Carousel plugin to load
        if (!jQuery.fn.owlCarousel) {
            jQuery(window).on('load', function () {
                warriorsSlider();
            });
            return;
        }

        // Find the initially checked warrior index
        var startIndex = 0;
        var $checked = $list.find('input[name="active-warrior[]"]:checked');
        if ($checked.length) {
            startIndex = $list.find('li').index($checked.closest('li'));
        }

        $list.addClass('owl-carousel');

        $list.owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            dots: false,
            startPosition: startIndex,
            margin: 20,
            navText:[
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="29" viewBox="0 0 16 29" fill="none">   <path d="M14.9142 1L1.41422 14.5L14.9142 28" stroke="#78FAAE" stroke-width="2" stroke-linecap="round"/> </svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="29" viewBox="0 0 16 29" fill="none">   <path d="M1 1L14.5 14.5L1 28" stroke="#78FAAE" stroke-width="2" stroke-linecap="round"/> </svg>'
            ]
        });

        // When slide changes, check the corresponding radio
        $list.on('changed.owl.carousel', function (e) {
            var index = e.item.index;
            var $radio = $list.find('.owl-item').not('.cloned').eq(index).find('input[type="radio"]');
            if ($radio.length && !$radio.prop('checked')) {
                $radio.prop('checked', true).trigger('change');
            }
        });
    }

    return LEtape26;
})();
